import React from "react";
import jQuery from "jquery";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;
/**
 * Se encarga de construir un modal dialog que permite desplegar
 * mensajes.
 */
export default class Collapse extends React.Component {
  state = {
    open: false
  };

  /**
   * Cuando se renderiza el componete se setea la referencia al
   * componente.
   */
  componentDidMount() {
    this.props.onRef(this);
  }

  /**
   * Se encarga de hacer el toogle del componete.
   */
  toggle() {
    this.$el.toggle(500);
  }

  /**
   * Renderiza el componente
   */
  render() {
    const { open } = this.props;
    return (
      <div
        className={this.props.styleName}
        style={{ display: !open ? "none" : "block" }}
        ref={ref => (this.$el = jQuery(ref))}
      >
        {this.props.children}
      </div>
    );
  }
}
